import { useNavigate, useParams } from "react-router";

import { useMainLayoutProvider } from "@providers/MainLayoutProvider/useMainLayoutProvider";

import { CurrentUser } from "@components/CurrentUser/CurrentUser";
import { ClientMenu, OrganizationMenu } from "@components/Menus";

import { Box } from "@design-system/Box/Box";
import { Clickable } from "@design-system/Clickable/Clickable";
import { IconButton } from "@design-system/IconButton/IconButton";

import { routes } from "@pages/routes";

import { useBreakpoint } from "@utils/hooks/useBreakpoint";

import classes from "./MainNavigation.module.css";

export const MainNavigation = () => {
  const navigate = useNavigate();
  const { isSmallerThan } = useBreakpoint();
  const { closeMobileNavigation } = useMainLayoutProvider();

  const { clientId } = useParams();

  const handleProfileClick = () => {
    closeMobileNavigation();
    navigate(routes.portal.profile.$path(), { viewTransition: true });
  };

  return (
    <div className={classes.container}>
      {isSmallerThan.laptop && (
        <Box padding="16px" justify="flex-end">
          <IconButton icon="faXmark" onClick={closeMobileNavigation} />
        </Box>
      )}

      {clientId ? <ClientMenu /> : <OrganizationMenu />}

      <footer className={classes.footer}>
        <Box direction="column" gap={12} fullStretch>
          <Clickable onClick={handleProfileClick} outline="sm" stretch>
            <CurrentUser />
          </Clickable>
        </Box>
      </footer>
    </div>
  );
};
